import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFAB() {
  const { settings } = useApp();
  const num = (settings.whatsapp || "").replace(/[^0-9]/g, "");
  if (!num) return null;
  return (
    <a data-testid="whatsapp-fab" href={`https://wa.me/${num}`} target="_blank" rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full grid place-items-center text-white shadow-xl"
      style={{background:"#25D366", boxShadow:"0 12px 30px -8px rgba(37,211,102,.6)"}}>
      <MessageCircle className="w-6 h-6"/>
    </a>
  );
}
